import React, { useCallback } from 'react';

import { ReactComponent as XIcon } from '../../../common/svg/general/icon-x.svg';
import { useSwitchChain } from '../../../hooks';
import type { WEB3_CONFIG } from '../../../lib';
import { Button, Colors } from '../../legacy/button/Button.component';
import styles from './WrongNetworkModal.module.css';

interface Props {
  currentNetwork: string;
  correctNetwork: typeof WEB3_CONFIG.chains[keyof typeof WEB3_CONFIG.chains]['id'];
  hideModal: () => void;
  onClick?: () => void;
}

interface WrongNetworkProps {
  hideModal: () => void;
}

const WrongNetwork: React.FC<Props> = ({
  currentNetwork,
  correctNetwork,
  hideModal,
}: Props) => {
  const { switchNetworkAsync } = useSwitchChain();

  const switchNetwork = useCallback(() => {
    void switchNetworkAsync?.(correctNetwork);

    hideModal();
  }, [hideModal, correctNetwork, switchNetworkAsync]);

  return (
    <div className={styles.wrongNetworkModal}>
      <div className={styles.headerDiv}>
        <h1>Looks like you’re on the wrong network</h1>
        <button className={styles.xIcon} onClick={hideModal}>
          <XIcon />
        </button>
      </div>
      <p className={styles.bodyText}>
        You’re currently on the{' '}
        <span className={styles.specialText}>{currentNetwork}</span> network
        when you should be on the{' '}
        <span className={styles.specialText}>{correctNetwork}</span> network.
      </p>

      <Button
        color={Colors.COLOR_SCHEME_2}
        className={styles.gotItButton}
        onClick={switchNetwork}
      >
        <p>Switch To {correctNetwork}</p>
      </Button>
    </div>
  );
};

export const WrongNetworkModal =
  (
    currentNetwork: Props['currentNetwork'],
    correctNetwork: Props['correctNetwork'],
  ) =>
  ({ hideModal }: WrongNetworkProps) => {
    return (
      <WrongNetwork
        currentNetwork={currentNetwork}
        correctNetwork={correctNetwork}
        hideModal={hideModal}
      />
    );
  };
